import { Component, inject } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { ApiService } from '@core/service/api.service';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss'
})
export class SnackbarComponent {
  message: any;
  snackBarRef = inject(MatSnackBarRef);
  constructor(public apiService: ApiService) { }

  ngOnInit() {
    this.message = this.apiService.modelMessage
  }
}
